import Vue from 'vue'
import myDialog from './myDialog/index.vue'

let obj = {
  myDialog,
}

for (const key in obj) {
  Vue.component(key,obj[key]);
}
